"use client"

import { motion } from "framer-motion"
import { MessageSquare, CheckCircle, Clock, CreditCard, Shield } from "lucide-react"
import "../styles/ComoContratar.css"

const ComoContratar = () => {
  const numeroWhatsApp = "5583991740119" // Substitua pelo seu número no formato internacional

  const handleContato = () => {
    window.open(`https://wa.me/${numeroWhatsApp}`, "_blank")
  }

  const beneficios = [
    {
      icon: <CheckCircle size={20} />,
      texto: "Venda antecipada de senhas com total segurança",
    },
    {
      icon: <CreditCard size={20} />,
      texto: "Múltiplas formas de pagamento: PIX, boleto e cartão de crédito",
    },
    {
      icon: <Clock size={20} />,
      texto: "Painel administrativo com relatórios em tempo real",
    },
    {
      icon: <Shield size={20} />,
      texto: "Suporte técnico durante todo o processo de vendas",
    },
  ]

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="contratar-container"
    >
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="titulo"
      >
        Como Contratar
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.3 }}
      >
        Quer levar mais praticidade para sua vaquejada? A <strong>Ticket do Vaqueiro</strong> oferece a solução ideal
        para gerenciamento e venda antecipada de senhas!
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.4 }}
        className="beneficios"
      >
        {beneficios.map((beneficio, index) => (
          <motion.div
            key={index}
            className="beneficio-item"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: 0.5 + index * 0.1 }}
          >
            <div className="beneficio-icon">{beneficio.icon}</div>
            <div className="beneficio-texto">{beneficio.texto}</div>
          </motion.div>
        ))}
      </motion.div>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.9 }}
      >
        Para contratar nosso serviço é simples: basta entrar em contato conosco pelo WhatsApp. Estamos prontos para
        esclarecer todas as suas dúvidas e fornecer todas as informações necessárias para que sua vaquejada seja um
        sucesso!
      </motion.p>

      <motion.button
        className="botao-whatsapp"
        onClick={handleContato}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 1.0 }}
      >
        <MessageSquare size={20} />
        Fale conosco pelo WhatsApp
      </motion.button>
    </motion.div>
  )
}

export default ComoContratar
